import { AuthApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useLogout } from '../useLogout';

const useHttpPostSignOut = () => {
    const authApi: AuthApi = useContainer(AuthApi);
    const { logoutUser } = useLogout();

    const postSignoutCleanup = (clearCacheCallback: () => void) => {
        logoutUser(clearCacheCallback);
    };

    const exec = () => {
        const { exec, clearCache, abort } = authApi.signOut({
            onSuccess: _ => postSignoutCleanup(clearCache),
            onError: _ => postSignoutCleanup(clearCache),
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostSignOut;
